module.exports = "<main role=\"main\" class=\"flex-shrink-0\">\n  <div class=\"\">\n    <router-outlet></router-outlet>\n  </div>\n</main>"